import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1505_1006">
        <rect width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1006)">
      <path
        d="M70 63.334L76.6641 63.334L76.6641 70L3.33203 70L3.33203 63.334L10 63.334L10 13.334C10 11.4922 11.4922 10 13.332 10L46.6641 10C48.5078 10 50 11.4922 50 13.334L50 63.334L63.332 63.334L63.332 36.666L56.6641 36.666L56.6641 30L66.6641 30C68.5078 30 70 31.4922 70 33.334L70 63.334ZM16.6641 16.666L16.6641 63.334L43.332 63.334L43.332 16.666L16.6641 16.666ZM23.332 36.666L36.6641 36.666L36.6641 43.334L23.332 43.334L23.332 36.666ZM23.332 23.334L36.6641 23.334L36.6641 30L23.332 30L23.332 23.334Z"
        fill="#FF32D3"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
